import { Product } from "@/data/data";
import React from "react";
interface DescriptionContentProps {
  itemData: Product[];
}
function DescriptionContent({ itemData }: DescriptionContentProps) {
  return (
    <>
      {itemData.map((item, index) => (
        <div key={index} className="w-full">
          {item.description ? (
            <section className="rounded-xl border border-slate-200/80 bg-slate-50/50 px-4 py-3.5 dark:border-slate-600/80 dark:bg-slate-800/40 sm:px-5 sm:py-4">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                About this item
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-700 dark:text-slate-300">
                {item.description}
              </p>
            </section>
          ) : null}
        </div>
      ))}
    </>
  );
}

export default DescriptionContent;
